module.exports = __webpack_public_path__ + "img/img_fps04.99dd8922.jpg";